export enum ConversationResponseTakeError {
  missingConversationLogId = 'missingConversationLogId',
}
